import Link from 'next/link';
import { Mail, Phone, MapPin, Github, Twitter, Linkedin } from 'lucide-react';

const Footer = () => {

    return (
        <footer className="bg-white border-t border-gray-100 pt-24 pb-12">
            <div className="container mx-auto px-4 max-w-7xl">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-16 mb-20">
                    {/* Brand Section */}
                    <div className="space-y-6">
                        <Link href="/" className="flex items-center gap-2">
                            <div className="h-10 w-10 rounded-lg overflow-hidden bg-white border border-gray-100 flex items-center justify-center shadow-sm">
                                <img
                                    src="/logoweb.jpeg"
                                    alt="Bioshphere"
                                    className="h-full w-full object-contain"
                                />
                            </div>
                            <span className="font-bold text-2xl tracking-tighter text-[#1d1d1f]">
                                Biosh<span className="text-teal-500">phere</span>
                            </span>
                        </Link>
                        <p className="text-gray-400 text-sm leading-relaxed max-w-xs font-medium tracking-tight">
                            The intelligent ecosystem for modern dining. Empowering restaurateurs with technology that feels like magic.
                        </p>
                        <div className="flex gap-4">
                            <a href="#" className="p-2.5 rounded-lg bg-gray-50 text-gray-400 hover:text-teal-500 hover:bg-teal-50 transition-all hover:scale-110 shimmer border border-transparent hover:border-teal-100">
                                <Twitter className="w-5 h-5" />
                            </a>
                            <a href="#" className="p-2.5 rounded-lg bg-gray-50 text-gray-400 hover:text-teal-500 hover:bg-teal-50 transition-all hover:scale-110 shimmer border border-transparent hover:border-teal-100">
                                <Linkedin className="w-5 h-5" />
                            </a>
                            <a href="#" className="p-2.5 rounded-lg bg-gray-50 text-gray-400 hover:text-teal-500 hover:bg-teal-50 transition-all hover:scale-110 shimmer border border-transparent hover:border-teal-100">
                                <Github className="w-5 h-5" />
                            </a>
                        </div>
                    </div>

                    {/* Links - Product */}
                    <div>
                        <h3 className="font-bold text-[#1d1d1f] text-sm uppercase tracking-widest mb-8">Product</h3>
                        <ul className="space-y-4">
                            {["Features", "Integration", "Enterprise", "Solutions"].map(l => (
                                <li key={l}>
                                    <Link href="#" className="text-gray-500 hover:text-black transition-colors">{l}</Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Links - Support */}
                    <div>
                        <h3 className="font-bold text-[#1d1d1f] text-sm uppercase tracking-widest mb-8">Support</h3>
                        <ul className="space-y-4">
                            {["Help Center", "API Status", "Contact Us", "Training"].map(l => (
                                <li key={l}>
                                    <Link href="#" className="text-gray-500 hover:text-black transition-colors">{l}</Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Contact Info */}
                    <div>
                        <h3 className="font-bold text-[#1d1d1f] text-sm uppercase tracking-widest mb-8">Contact</h3>
                        <ul className="space-y-4 text-gray-500 font-medium">
                            <li className="flex items-center gap-3">
                                <Mail className="w-5 h-5 text-teal-500" />
                                <span>hello@Bioshphere.com</span>
                            </li>
                            <li className="flex items-center gap-3">
                                <Phone className="w-5 h-5 text-teal-500" />
                                <span>+91 (800) 123-4567</span>
                            </li>
                            <li className="flex items-center gap-3">
                                <MapPin className="w-5 h-5 text-teal-500" />
                                <span>Made with ❤️ in India</span>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="pt-8 border-t border-gray-100 flex flex-col md:flex-row justify-between items-center gap-6">
                    <p className="text-gray-400 text-sm font-medium">
                        Powered by Bioshphere.
                    </p>
                    <div className="flex gap-8 text-sm text-gray-400 font-medium">
                        <Link href="#" className="hover:text-[#1d1d1f] transition-colors">Privacy Policy</Link>
                        <Link href="#" className="hover:text-[#1d1d1f] transition-colors">Terms of Service</Link>
                        <Link href="#" className="hover:text-[#1d1d1f] transition-colors">Cookies Settings</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
